export default "__VITE_ASSET__DgVR346U__"